import { render, staticRenderFns } from "./LawMatterTypeForm.vue?vue&type=template&id=04f97273&"
import script from "./LawMatterTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterTypeForm.vue?vue&type=style&index=0&id=04f97273&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports